import React from 'react'

import { FormattedMessage } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'

import { usePreapprovalAmountPercentage } from '@hooks/usePreapprovalAmountPercentage'
import { IApplicationState } from '@store'
import { preApprove, selectIsPreApproving } from '@store/submissions'
import { Button, Header } from '@tribegroup'

interface IProps {
  submissionId: number
  campaignId: number
}

const SubmissionCardModalPreApprovalPreapprovalCTA: React.FC<IProps> = ({
  submissionId,
  campaignId,
}) => {
  const percentage = usePreapprovalAmountPercentage()
  const isPreApproving = useSelector((state: IApplicationState) => selectIsPreApproving(state))
  const dispatch = useDispatch()

  const onClick = () => dispatch(preApprove(submissionId, campaignId))

  return (
    <Button
      fullWidth
      scheme="primary"
      height={3}
      onClick={onClick}
      loading={isPreApproving}
      disabled={isPreApproving}
      data-testid="pre-approval-cta"
    >
      <Header cta>
        <FormattedMessage
          id="submission.chat.preapproved.modal.cta"
          values={{
            percentage,
          }}
        />
      </Header>
    </Button>
  )
}

export default SubmissionCardModalPreApprovalPreapprovalCTA
